import BaseAgencyScopeEntityDto from '@/models/Shared/BaseAgencyScopeEntityDto';

export default class IndustryDto extends BaseAgencyScopeEntityDto {
    status = 0;
    name: string;
}